import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {RaceCommercialService} from "@services";
import {RaceCommercialItem} from "@model";

export const RaceCommercialItemsPublicResolver: ResolveFn<Observable<RaceCommercialItem[]> | RaceCommercialItem[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   raceCommercialService: RaceCommercialService = inject(RaceCommercialService)): Observable<RaceCommercialItem[]> | RaceCommercialItem[] => {
    if (+route.queryParams['raceId']) {
      return raceCommercialService.findPublicRaceCommercialItems(+route.queryParams['raceId']);
    } else {
      return [];
    }
  }
